<template>
    <TheHeader bgClass="header-bg-color" fontClass="fontColor2"/>

    <ThePageSubTitle titleMsg="Project Gallery" msg="Our Work in Action"/>
    <br/>
    <br/>

    <TheGalleryLightBox/>

    <br/>
    <br/>

    <TheSponsor bgClass="header-bg-color"/>

    <!-- Copyright -->
    <TheCopyRight/>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheGalleryLightBox from '@/components/TheGalleryLightBox.vue'
import TheSponsor from '@/components/TheSponsor.vue'
import TheCopyRight from '@/components/TheCopyRight.vue'
import ThePageSubTitle from '@/components/ThePageSubTitle.vue'

export default {
  name: 'About Us',
  components: {
    TheHeader,
    TheSponsor,
    TheCopyRight,
    TheGalleryLightBox,
    ThePageSubTitle
  }
}

</script>

<style scoped>

</style>